<section>
    <div>
      <h1>Help</h1>
      <button (click)="back.emit()">
        <img src="assets/icons/back.svg" alt="back button">
      </button>
    </div>
    
    <p>
      Welcome to the help page for <span class="blue">Join</span>, your guide to using our kanban project
      management tool. Here, we'll provide an overview of what <span class="blue">Join</span> is, how it
      can benefit you, and how to use it.
    </p>
    <h3>What is Join?</h3>
    <p>
      <span class="blue">Join</span> is a kanban-based project management tool designed and built by a
      group of dedicated students as part of their web development bootcamp at
      the Developer Akademie.
    </p>
    <p>
      Kanban, a Japanese term meaning "billboard", is a highly effective method
      to visualize work, limit work-in-progress, and maximize efficiency (or
      flow). <span class="blue">Join</span> leverages the principles of kanban to help users manage their
      tasks and projects in an intuitive, visual interface.
    </p>
    <p>
      It is important to note that <span class="blue">Join</span> is designed as an educational exercise
      and is not intended for extensive business usage. While we strive to
      ensure the best possible user experience, we cannot guarantee consistent
      availability, reliability, accuracy, or other aspects of quality regarding
      <span class="blue">Join</span>.
    </p>
    <h3>How to use it?</h3>
    <p>Here is a step-by-step guide on how to use <span class="blue">Join</span>:</p>
    <ol type="1">
      <li>
        <h5>Exploring the Board</h5>
        <p>When you log in to <span class="blue">Join</span>, you'll find a default board. This board
        represents your project and contains four default lists: "To Do", "In
        Progress", “Await feedback” and "Done".</p>
      </li>
      <li>
        <h5>Creating Contacts</h5> 
        <p>In <span class="blue">Join</span>, you can add contacts to collaborate on your
        projects. Go to the "Contacts" section, click on "New contact", and fill
        in the required information. Once added, these contacts can be assigned
        tasks and they can interact with the tasks on the board.</p>
      </li>
      <li>
        <h5>Adding Cards</h5> 
        <p>Now that you've added your contacts, you can start adding
        cards. Cards represent individual tasks. Click the "+" button under the
        appropriate list to create a new card. Fill in the task details in the
        card, like task name, description, due date, assignees, etc.</p>
      </li>
      <li>
        <h5>Moving Cards</h5> 
        <p>As the task moves from one stage to another, you can
        reflect that on the board by dragging and dropping the card from one
        list to another.</p>
      </li>
      <li>
        <h5>Deleting Cards</h5>
        <p>Once a task is completed, you can either move it to the
        "Done" list or delete it. Deleting a card will permanently remove it
        from the board. Please exercise caution when deleting cards, as this
        action is irreversible.</p>
      </li>
    </ol>
  <p>
    Remember that using <span class="blue">Join</span> effectively requires consistent updates from you
    and your team to ensure the board reflects the current state of your
    project.
  </p>

  <p>
    Have more questions about <span class="blue">Join</span>? Feel free to contact us at felicia.primadita&#64;web.de. We're here to help you!
  </p>
  <h3>Enjoy using Join!</h3>
</section>
